import CryptoJS from 'crypto-js';

/**
 * Generate HMAC signature
 * HARUS IDENTIK dengan backend Laravel
 */
export function generateHmacSignature(timestamp, method, path, secret) {
  const payload = `${timestamp}|${method.toUpperCase()}|${path}`;
  return CryptoJS.HmacSHA256(payload, secret).toString();
}
